{
  "name": "fsmapkit",
  "version": "1.0.1",
  "description": "📁 CLI to visualize and export the file structure of any folder or GitHub repo",
  "author": "Swasthik K <swasthk.work@gmail.com>",
  "license": "MIT",
  "bin": {
    "fsmap": "./dist/index.js"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "keywords": [
    "cli",
    "folder-structure",
    "directory-tree",
    "filesystem",
    "fsmap",
    "markdown",
    "json",
    "visualize",
    "tree",
    "github"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/SwasthK/fsmap"
  },
  "bugs": {
    "url": "https://github.com/SwasthK/fsmap/issues"
  },
  "homepage": "https://github.com/SwasthK/fsmap#readme",
  "scripts": {
    "start": "ts-node src/index.ts",
    "build": "tsup",
    "build:watch": "tsup --watch",
    "test": "vitest",
    "knip": "knip"
  },
  "dependencies": {
    "cli-spinner": "^0.2.10",
    "commander": "^14.0.0",
    "simple-git": "^3.27.0"
  },
  "devDependencies": {
    "@types/cli-spinner": "^0.2.3",
    "@types/commander": "^2.12.0",
    "@types/node": "^22.15.21",
    "ts-node": "^10.9.2",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ]
}
